export default __webpack_public_path__ + "static/media/itas-assicurazioni.icon.cc7ad2af.svg";